import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const SubscriptionChannels = {
    email: 'email',
    push: 'push',
    unknown: 'unknown'
};
export const SubscriptionTopics = {
    intradayDailies: 'intraday-dailies',
    food: 'intraday-dailies.food',
    medication: 'intraday-dailies.medication',
    skinApplication: 'intraday-dailies.skin_application',
    nap: 'intraday-dailies.nap',
    note: 'intraday-dailies.note',
    bathroom: 'intraday-dailies.bathroom',
    pleaseBringReminder: 'intraday-dailies.note.please-bring-reminder',
    checkin: 'checkin',
    unknown: 'unknown'
};
export const SubscriptionChannel = Type.Union([
    Type.Literal(SubscriptionChannels.email),
    Type.Literal(SubscriptionChannels.push),
    Type.Literal(SubscriptionChannels.unknown)
]);
export const SubscriptionChannelCodec = createFallbackStringEnumCodec(SubscriptionChannels, SubscriptionChannels.unknown);
export const SubscriptionTopicId = Type.Union([
    Type.Literal(SubscriptionTopics.intradayDailies),
    Type.Literal(SubscriptionTopics.food),
    Type.Literal(SubscriptionTopics.medication),
    Type.Literal(SubscriptionTopics.skinApplication),
    Type.Literal(SubscriptionTopics.nap),
    Type.Literal(SubscriptionTopics.note),
    Type.Literal(SubscriptionTopics.bathroom),
    Type.Literal(SubscriptionTopics.pleaseBringReminder),
    Type.Literal(SubscriptionTopics.checkin),
    Type.Literal(SubscriptionTopics.unknown)
]);
export const SubscriptionTopicIdCodec = createFallbackStringEnumCodec(SubscriptionTopics, SubscriptionTopics.unknown);
export const ConfigurableSubscriptionChannel = Type.Object({
    channel: SubscriptionChannelCodec
});
export const ConfigurableSubscriptionTopic = Type.Object({
    topic: SubscriptionTopicIdCodec,
    channel: SubscriptionChannelCodec
});
export const ConfigurableSubscriptions = Type.Object({
    channels: Type.Array(ConfigurableSubscriptionChannel),
    topics: Type.Array(ConfigurableSubscriptionTopic)
});
export const SubscriptionTopic = Type.Object({
    topic: SubscriptionTopicIdCodec,
    channels: Type.Array(SubscriptionChannelCodec)
});
export const Subscriptions = Type.Object({
    channels: Type.Array(SubscriptionChannelCodec),
    topics: Type.Array(SubscriptionTopic)
});
